import Auxiliary from "../../hoc/auxiliary/auxiliary";
import upArrow from "../../assets/icons/up-arrow.svg";
import { useEffect } from "react";

const ScrollTopView = (props) => {
  const { onScroll, onVisbile, visible, isInProfilePage } = props;

  useEffect(() => {
    if (typeof window === 'object') {
      window.addEventListener('scroll', onVisbile);
    }
    return () => {
      window.removeEventListener('scroll', onVisbile);
    }
  }, []);

  return (
    <Auxiliary>
      {
        visible ?
          <div
            className={`scroll-top ${isInProfilePage ? "scrool-top-profile" : ""} `}
            onClick={onScroll}
          >
            <img src={upArrow} alt="" />
          </div>
          : null
      }
    </Auxiliary>
  )
}

export default ScrollTopView